import { render } from "./PatientRecordDialog.vue?vue&type=template&id=0c2d0cf2"
import script from "./PatientRecordDialog.vue?vue&type=script&lang=js"
export * from "./PatientRecordDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__